var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD652"
    },
    points: "289.643,110.916 289.643,178.201 424.214,258.103 424.214,31.014  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD652"
    },
    points: "222.357,178.201 87.786,258.103 87.786,31.014 222.357,110.916  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 407.392,
    y: 81.132,
    style: {
      fill: "#FB9D46"
    },
    width: 33.643,
    height: 42.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.392,
    y: 9.988,
    style: {
      fill: "#FB9D46"
    },
    width: 33.643,
    height: 269.142
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.392,
    y: 236.729,
    style: {
      fill: "#FB9D46"
    },
    width: 33.643,
    height: 42.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.965,
    y: 9.988,
    style: {
      fill: "#FB9D46"
    },
    width: 33.643,
    height: 269.142
  })), /*#__PURE__*/React.createElement("rect", {
    x: 407.392,
    y: 60.452,
    style: {
      fill: "#FFD652"
    },
    width: 33.643,
    height: 42.053
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 407.392,
    y: 236.729,
    style: {
      fill: "#FF7452"
    },
    width: 33.643,
    height: 42.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.965,
    y: 236.729,
    style: {
      fill: "#FF7452"
    },
    width: 33.643,
    height: 42.4
  })), /*#__PURE__*/React.createElement("rect", {
    x: 70.965,
    y: 60.452,
    style: {
      fill: "#FFD652"
    },
    width: 33.643,
    height: 42.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.179,
    y: 203.433,
    style: {
      fill: "#B2B2B2"
    },
    width: 33.643,
    height: 75.696
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.179,
    y: 203.433,
    style: {
      fill: "#999999"
    },
    width: 33.643,
    height: 25.232
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7452"
    },
    d: "M290.694,203.433h-69.388c-8.709,0-15.77-7.061-15.77-15.77v-86.209c0-8.709,7.061-15.77,15.77-15.77 h69.388c8.709,0,15.77,7.061,15.77,15.77v86.209C306.464,196.372,299.403,203.433,290.694,203.433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E24642"
    },
    d: "M230.768,187.663v-86.209c0-8.709,7.061-15.77,15.77-15.77h-25.232c-8.709,0-15.77,7.061-15.77,15.77 v86.209c0,8.709,7.061,15.77,15.77,15.77h25.232C237.829,203.433,230.768,196.372,230.768,187.663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#458FDE"
    },
    d: "M286.489,502.012h-60.977c-8.709,0-15.77-7.061-15.77-15.77v-66.234c0-17.42,14.12-31.54,31.54-31.54 h29.437c17.42,0,31.54,14.12,31.54,31.54v66.234C302.259,494.952,295.198,502.012,286.489,502.012z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4F5AA8"
    },
    d: "M234.973,486.242v-66.234c0-17.42,14.12-31.54,31.54-31.54h-25.232c-17.42,0-31.54,14.12-31.54,31.54 v66.234c0,8.709,7.061,15.77,15.77,15.77h25.232C242.034,502.012,234.973,494.952,234.973,486.242z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F7EDBC"
    },
    cx: 275.975,
    cy: 114.07,
    r: 13.667
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M441.035,2.103h-33.643c-4.356,0-7.885,3.53-7.885,7.885v25.277L310.3,88.232c-4.256-6.29-11.456-10.433-19.606-10.433 h-69.388c-8.534,0-16.025,4.543-20.187,11.338l-88.626-52.622V9.988c0-4.355-3.53-7.885-7.885-7.885H70.965 c-4.355,0-7.885,3.53-7.885,7.885v269.142c0,4.355,3.53,7.885,7.885,7.885h33.643c4.355,0,7.885-3.53,7.885-7.885v-26.526 l88.626-52.621c4.161,6.794,11.653,11.337,20.187,11.337h9.988v67.811c0,4.355,3.53,7.885,7.885,7.885h8.936v14.193 c0,13.044,10.612,23.655,23.655,23.655h26.283c4.356,0,7.885-3.53,7.885-7.885c0-4.355-3.529-7.885-7.885-7.885H271.77 c-4.348,0-7.885-3.537-7.885-7.885v-14.193h8.936c4.356,0,7.885-3.53,7.885-7.885v-67.811h9.988c8.534,0,16.026-4.543,20.187-11.337 l88.281,52.416c0.112,0.067,0.231,0.115,0.346,0.175v26.557c0,4.355,3.529,7.885,7.885,7.885h33.643c4.356,0,7.885-3.53,7.885-7.885 V9.988C448.92,5.633,445.391,2.103,441.035,2.103z M96.723,271.244H78.85V17.873h17.873V271.244z M112.493,54.853l84.812,50.357 c0.112,0.067,0.231,0.115,0.346,0.175V183.7l-85.158,50.563L112.493,54.853L112.493,54.853z M264.936,271.244h-17.873v-59.926 h17.873V271.244z M314.349,183.701V161.38c0-4.355-3.529-7.885-7.885-7.885s-7.885,3.53-7.885,7.885v26.283 c0,4.348-3.537,7.885-7.885,7.885h-69.388c-4.348,0-7.885-3.537-7.885-7.885v-86.209c0-4.348,3.537-7.885,7.885-7.885h69.388 c4.348,0,7.885,3.537,7.885,7.885v24.181c0,4.355,3.529,7.885,7.885,7.885s7.885-3.53,7.885-7.885v-21.466l85.158-50.563v180.658 L314.349,183.701z M433.15,271.244h-17.873V17.873h17.873V271.244z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M504.115,136.674h-29.437c-4.356,0-7.885,3.53-7.885,7.885c0,4.355,3.529,7.885,7.885,7.885h29.437 c4.356,0,7.885-3.53,7.885-7.885C512,140.204,508.471,136.674,504.115,136.674z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M474.682,101.979c1.779,0,3.57-0.599,5.044-1.827l25.232-21.027c3.345-2.788,3.796-7.76,1.009-11.105 c-2.787-3.345-7.759-3.798-11.105-1.009L469.63,88.038c-3.345,2.788-3.796,7.76-1.009,11.105 C470.18,101.014,472.421,101.979,474.682,101.979z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M504.958,209.992l-25.232-21.027c-3.344-2.786-8.316-2.336-11.105,1.009c-2.787,3.345-2.336,8.317,1.009,11.105 l25.232,21.027c1.474,1.228,3.263,1.827,5.044,1.827c2.258,0,4.502-0.966,6.062-2.838 C508.755,217.751,508.302,212.78,504.958,209.992z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.322,152.444c4.355,0,7.885-3.53,7.885-7.885c0-4.355-3.53-7.885-7.885-7.885H7.885c-4.355,0-7.885,3.53-7.885,7.885 c0,4.355,3.53,7.885,7.885,7.885H37.322z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.37,88.037L17.138,67.01c-3.345-2.787-8.317-2.335-11.105,1.009c-2.788,3.345-2.336,8.317,1.009,11.105l25.232,21.027 c1.475,1.229,3.264,1.828,5.044,1.828c2.259,0,4.502-0.966,6.062-2.838C46.168,95.797,45.715,90.825,42.37,88.037z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.275,188.965L7.043,209.992c-3.345,2.788-3.797,7.76-1.009,11.105c1.559,1.871,3.803,2.838,6.062,2.838 c1.78,0,3.57-0.599,5.043-1.827l25.232-21.027c3.345-2.788,3.797-7.76,1.009-11.105C40.592,186.629,35.619,186.177,32.275,188.965z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M408.444,309.092h-76.747c-4.356,0-7.885,3.53-7.885,7.885c0,4.355,3.529,7.885,7.885,7.885h76.747 c4.348,0,7.885,3.537,7.885,7.885v14.719c0,4.348-3.537,7.885-7.885,7.885H271.77c-13.043,0-23.655,10.611-23.655,23.655v1.577 h-6.834c-21.74,0-39.425,17.686-39.425,39.425v66.234c0,13.044,10.611,23.655,23.655,23.655h60.977 c13.043,0,23.655-10.611,23.655-23.655v-66.234c0-21.74-17.686-39.425-39.425-39.425h-6.834v-1.577c0-4.348,3.537-7.885,7.885-7.885 h136.674c13.043,0,23.655-10.611,23.655-23.655v-14.719C432.099,319.704,421.486,309.092,408.444,309.092z M241.281,396.353h6.834 v30.489h-30.489v-6.834C217.626,406.964,228.237,396.353,241.281,396.353z M286.489,494.127h-60.977 c-4.348,0-7.885-3.537-7.885-7.885v-43.63h76.747v43.63C294.374,490.591,290.837,494.127,286.489,494.127z M294.374,420.008v6.834 h-30.489v-30.489h6.834C283.762,396.353,294.374,406.964,294.374,420.008z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketing);
export default __webpack_public_path__ + "static/media/marketing.633d31dcc93805df5f8daebafee6f249.svg";
export { ForwardRef as ReactComponent };